import { render, staticRenderFns } from "./UserAccountBranding.vue?vue&type=template&id=a43cc7a0&scoped=true&"
import script from "./UserAccountBranding.vue?vue&type=script&lang=js&"
export * from "./UserAccountBranding.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountBranding.vue?vue&type=style&index=0&id=a43cc7a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43cc7a0",
  null
  
)

export default component.exports